module.exports = __webpack_public_path__ + "img/21DayFixExtreme.59f05b7c.jpeg";